/**
 * @generated SignedSource<<60da125b78de5e58adfc89fb13a4d860>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserContactStatus = "ELIGIBLE_FOR_ACTIVATION" | "NOT_TAKEN" | "UNVERIFIED" | "VERIFIED";
export type UserPhoneStatusInput = {
  phoneNumber: string;
};
export type useCheckUserPhoneStatusNotificationsMutation$variables = {
  input: UserPhoneStatusInput;
};
export type useCheckUserPhoneStatusNotificationsMutation$data = {
  readonly responsePayload: {
    readonly errors: ReadonlyArray<{
      readonly code: string;
      readonly field: ReadonlyArray<string | null | undefined>;
      readonly message: string | null | undefined;
    } | null | undefined>;
    readonly result: UserContactStatus | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useCheckUserPhoneStatusNotificationsMutation = {
  response: useCheckUserPhoneStatusNotificationsMutation$data;
  variables: useCheckUserPhoneStatusNotificationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "result",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCheckUserPhoneStatusNotificationsMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UserPhoneStatusPayload",
        "kind": "LinkedField",
        "name": "userPhoneStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCheckUserPhoneStatusNotificationsMutation",
    "selections": [
      {
        "alias": "responsePayload",
        "args": (v1/*: any*/),
        "concreteType": "UserPhoneStatusPayload",
        "kind": "LinkedField",
        "name": "userPhoneStatus",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9f569b4119ee81a0b60f25651e12edab",
    "id": null,
    "metadata": {},
    "name": "useCheckUserPhoneStatusNotificationsMutation",
    "operationKind": "mutation",
    "text": "mutation useCheckUserPhoneStatusNotificationsMutation(\n  $input: UserPhoneStatusInput!\n) {\n  responsePayload: userPhoneStatus(input: $input) {\n    success\n    result\n    errors {\n      __typename\n      field\n      code\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "282ad78c140683f6bee6546e79799a7d";

export default node;
